export default __webpack_public_path__ + "static/media/landing-page-head-img-1.f13afc34.jpg";